import React from 'react';

const Blogs = () => {
    return (
        <div className='w-11/12 mx-auto' id='blogs'>
                        <h1 className='text-3xl text-center text-gray-300 my-10'>Blogs</h1>

            <div className="hero-content">
                <div className="max-w-lg">
                    <h1 className="text-5xl font-bold text-gray-200">

                        
                        <br />
                    <span className='text-primary font-bold'>Coming Soon</span>

                    </h1>
                </div>
            </div>
        </div>
    );
};

export default Blogs;